import React from "react";
import ComingSoon from "../../../components/ComingSoon";

export default function Compliance() {
  return <ComingSoon title="HR Compliance & Audit" />;
}
